module.exports = __webpack_public_path__ + "static/energi-3bae083d01daf20cfffb8d79ded470e9.svg";